import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ shape, palette, custom, breakpoints }: Theme) => ({
    requiredFielAsterisk: {
      fontSize: 16,
      color: palette.primary.main,
    },
    consentRequired: {
      position: 'absolute',
      left: 23,
      top: 3,
    },
    consentWrapper: {
      position: 'relative',
    },
  })
);
